import React from 'react';
import { GenericDetailPage } from '../../components/generic';
import { useRecurringPayable, RecurringPayable } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';

const Detail: React.FC = () => {
  return (
    <GenericDetailPage<RecurringPayable>
      useData={useRecurringPayable}
      config={{
        ...moduleConfig,
        getDetailSections: (item) => getDetailSections(item, moduleConfig.utils.formatCurrency),
        getStatusBadges,
      }}
    />
  );
};

export default Detail;
